import React from "react";
import { useTranslation } from "react-i18next";
import SellersList from "./SellersList/SellersList";

const Title = () => {
  const { t } = useTranslation();
  return <h2 className="c-title--main">{t("Distributor Inventory")}</h2>;
};

export default function App() {
  return (
    <div className="j-tab">
      <Title />
      <SellersList />
    </div>
  );
}
